export default {
	highlightedIndex: state => state.highlightedIndex,
	highlightedRoute: state => state.highlightedRoute,
	isSearchOpen: state => state.isSearchOpen,
	term: state => state.term
}
